import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImageSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="image-sparkle, midjourney, ai generated, star"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4.5 4.5V14.4393L8 10.9393L16.5607 19.5H19.5V4.5H4.5ZM14.4393 19.5L8 13.0607L4.5 16.5607V19.5H14.4393Z" fill="currentColor"/><path d="M13.5 8.5L14.5 6.5L15.5 8.5L17.5 9.5L15.5 10.5L14.5 12.5L13.5 10.5L11.5 9.5L13.5 8.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconImageSparkle;
